var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRngParticipant = function SvgRngParticipant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.706.5h4.588c0 .834-1.001 1.53-2.336 1.53-1.251 0-2.252-.696-2.252-1.53Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.941 4.483c0 .15 0 .225-.08.3L17.227 7.64c0 .075-.16.15-.24.15-.16 0-.24 0-.32-.075L15.15 6.512v6.612c0 .15-.08.226-.16.3 0 0-.159.076-.239.076H5.25c-.16 0-.24 0-.32-.075-.08-.075-.08-.226-.08-.3V6.586L3.334 7.789c-.08.15-.24.15-.32.15-.08 0-.16-.15-.24-.225L.14 4.858c-.08-.075-.08-.225-.08-.3 0-.15.08-.226.16-.3L4.29 1.175A2.968 2.968 0 0 1 6.207.5h.799c0 1.353 1.357 2.405 3.034 2.405 1.597 0 2.955-1.052 2.955-2.405h.798c.719 0 1.357.225 1.916.676l4.073 3.081c.08.075.16.15.16.226Z",
    fill: "currentcolor"
  })));
};
export { SvgRngParticipant as ReactComponent };